<a class="btn-scroll-top-mobile" aria-label="Volver arriba" (click)="scrollToElement('top')">
  <img src="./assets/images/top-mobile.png" width="30px">
</a>
<button id="help-button33" class="btn boton-ayuda mobile-fixe" routerLink="help">
  <svg-icon svgName="bi-question-circle" [width]="30" [height]="30" />
</button>